/* Zamówienie z wyborem dostawy: "Zamów do Paczkomatu" (własna mapa z publicznego API InPost albo mapa Geowidget z tokenem) i "Zamów kurierem". */
(() => {
  if (window.__cpPkInit) return;
  window.__cpPkInit = true;

  const POINTS_API = 'https://api-pl-points.easypack24.net/v1/points';
  const GEOCODE_API = 'https://nominatim.openstreetmap.org/search';
  const LEAFLET = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4';
  const GEOWIDGET = {
    prod: 'https://geowidget.inpost.pl',
    sandbox: 'https://sandbox-easy-geowidget-sdk.easypack24.net',
  };

  let dialog = null;
  let dialogMode = '';
  let activeRoot = null;
  let geowidgetLoaded = false;
  let leafletPromise = null;

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });

  const loadCss = (href) => {
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  };

  const loadLeaflet = () => {
    if (window.L) return Promise.resolve();
    if (!leafletPromise) {
      loadCss(`${LEAFLET}/leaflet.css`);
      leafletPromise = loadScript(`${LEAFLET}/leaflet.js`);
    }
    return leafletPromise;
  };

  const loadGeowidget = (sandbox) => {
    if (geowidgetLoaded) return;
    geowidgetLoaded = true;
    const host = sandbox ? GEOWIDGET.sandbox : GEOWIDGET.prod;
    loadCss(`${host}/inpost-geowidget.css`);
    const js = document.createElement('script');
    js.src = `${host}/inpost-geowidget.js`;
    js.defer = true;
    document.head.appendChild(js);
  };

  const say = (root, text) => {
    const msg = root && root.querySelector('[data-cp-deliver-msg]');
    if (msg) msg.textContent = text;
  };

  const setBusy = (root, busy) => {
    root.querySelectorAll('[data-cp-deliver]').forEach((b) => {
      b.disabled = busy;
    });
  };

  const addressOf = (point) => {
    const a = point.address || {};
    const d = point.address_details || {};
    if (a.line1) return [a.line1, a.line2].filter(Boolean).join(', ');
    return [[d.street, d.building_number].filter(Boolean).join(' '), [d.post_code, d.city].filter(Boolean).join(' ')]
      .filter(Boolean)
      .join(', ');
  };

  const closeDialog = () => {
    if (dialog && dialog.open) dialog.close();
  };

  /* zapisuje wybór w koszyku i przechodzi do kasy */
  const saveAndCheckout = async (root, attributes) => {
    setBusy(root, true);
    say(root, 'Przechodzę do płatności...');
    try {
      const res = await fetch(root.dataset.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!res.ok) throw new Error('update');
      window.location.href = root.dataset.checkoutUrl;
    } catch (e) {
      setBusy(root, false);
      say(root, 'Nie udało się zapisać wyboru dostawy. Spróbuj jeszcze raz.');
    }
  };

  /* po wyborze punktu pokazujemy potwierdzenie: klient może zatwierdzić albo wrócić do mapy */
  const chooseByCode = (code, address, details) => {
    if (!activeRoot || !dialog || typeof dialog.cpShowConfirm !== 'function') return;
    dialog.cpShowConfirm(code, address, details || '');
  };

  const confirmChoice = (code, address) => {
    const root = activeRoot;
    if (!root) return;
    closeDialog();
    saveAndCheckout(root, { Dostawa: 'Paczkomat', Paczkomat: code, 'Paczkomat adres': address });
  };

  const baseDialog = (title, extraClass) => {
    const d = el('dialog', `cp-pk-dialog ${extraClass || ''}`.trim());
    d.setAttribute('aria-label', title);
    const bar = el('div', 'cp-pk-dialog__bar');
    const close = el('button', 'cp-pk-dialog__close', '×');
    close.type = 'button';
    close.setAttribute('data-cp-pk-close', '');
    close.setAttribute('aria-label', 'Zamknij');
    bar.append(el('p', 'cp-pk-dialog__title', title), close);
    d.appendChild(bar);

    /* zamykaj tylko, gdy kliknięcie zaczęło się i skończyło na tle (nie przy przeciąganiu mapy) */
    let downOnBackdrop = false;
    d.addEventListener('pointerdown', (e) => {
      downOnBackdrop = e.target === d;
    });
    d.addEventListener('click', (e) => {
      if ((e.target === d && downOnBackdrop) || e.target.closest('[data-cp-pk-close]')) d.close();
      downOnBackdrop = false;
    });
    d.addEventListener('close', () => {
      document.documentElement.classList.remove('cp-no-scroll');
      d.classList.remove('is-confirming');
    });

    const confirm = el('div', 'cp-pk-confirm');
    confirm.hidden = true;
    const cTitle = el('p', 'cp-pk-confirm__title', 'Twój Paczkomat');
    const cCode = el('p', 'cp-pk-confirm__code');
    const cAddr = el('p', 'cp-pk-confirm__addr');
    const cInfo = el('p', 'cp-pk-confirm__info');
    const cOk = el('button', 'cart__checkout-button button', 'Zatwierdź i przejdź do płatności');
    cOk.type = 'button';
    const cBack = el('button', 'cp-pk__btn cp-pk-confirm__back', 'Zmień Paczkomat');
    cBack.type = 'button';
    confirm.append(cTitle, cCode, cAddr, cInfo, cOk, cBack);
    d.appendChild(confirm);

    let current = null;
    d.cpShowConfirm = (code, address, details) => {
      current = { code, address };
      cCode.textContent = code;
      cAddr.textContent = address === 'wpisany ręcznie przez klienta' ? 'Numer wpisany ręcznie.' : address;
      cInfo.textContent = details || '';
      cInfo.hidden = !details;
      confirm.hidden = false;
      d.classList.add('is-confirming');
    };
    d.cpHideConfirm = () => {
      confirm.hidden = true;
      d.classList.remove('is-confirming');
      if (d.cpMap && typeof d.cpMap.invalidateSize === 'function') d.cpMap.invalidateSize();
    };
    cBack.addEventListener('click', () => d.cpHideConfirm());
    cOk.addEventListener('click', () => {
      if (current) confirmChoice(current.code, current.address);
    });
    document.body.appendChild(d);
    return d;
  };

  /* --- oficjalna mapa InPost (gdy jest token Geowidget) --- */
  const buildGeowidgetDialog = (token) => {
    const d = baseDialog('Wybierz Paczkomat InPost');
    const map = el('div', 'cp-pk-dialog__map');
    const widget = document.createElement('inpost-geowidget');
    widget.setAttribute('onpoint', 'cpPkSelected');
    widget.setAttribute('token', token);
    widget.setAttribute('language', 'pl');
    widget.setAttribute('config', 'parcelCollect');
    map.appendChild(widget);
    d.appendChild(map);
    return d;
  };

  window.cpPkSelected = (point) => {
    if (!point || !point.name) return;
    chooseByCode(point.name, addressOf(point));
  };

  /* --- własna mapa: OpenStreetMap + publiczne API punktów InPost (bez tokenu) --- */
  const buildOwnMapDialog = () => {
    const d = baseDialog('Wybierz Paczkomat InPost', 'cp-pk-dialog--own');

    const form = el('form', 'cp-pk-own__search');
    const input = el('input', 'cp-pk__input');
    input.type = 'search';
    input.placeholder = 'Miasto, kod pocztowy lub adres';
    input.setAttribute('aria-label', 'Miasto, kod pocztowy lub adres');
    input.autocomplete = 'off';
    const go = el('button', 'cp-pk__btn', 'Szukaj');
    go.type = 'submit';
    const near = el('button', 'cp-pk__btn cp-pk-own__near', 'Moja lokalizacja');
    near.type = 'button';
    form.append(input, go, near);

    const status = el('p', 'cp-pk-own__status', 'Wpisz miejscowość lub kod pocztowy albo przybliż mapę.');
    status.setAttribute('role', 'status');
    const mapEl = el('div', 'cp-pk-own__map');
    const list = el('ul', 'cp-pk-own__list');

    const manualToggle = el('button', 'cp-pk-own__manual-toggle', 'Znam numer Paczkomatu i wpiszę go ręcznie');
    manualToggle.type = 'button';
    const manual = el('div', 'cp-pk-own__manual');
    manual.hidden = true;
    const mInput = el('input', 'cp-pk__input');
    mInput.type = 'text';
    mInput.placeholder = 'np. KRA010M';
    mInput.maxLength = 14;
    mInput.autocapitalize = 'characters';
    mInput.setAttribute('aria-label', 'Numer Paczkomatu');
    const mOk = el('button', 'cp-pk__btn', 'Zatwierdź');
    mOk.type = 'button';
    const mErr = el('p', 'cp-pk__msg');
    manual.append(mInput, mOk, mErr);
    manualToggle.addEventListener('click', () => {
      manual.hidden = !manual.hidden;
      if (!manual.hidden) mInput.focus();
    });
    const submitManual = () => {
      const code = (mInput.value || '').toUpperCase().replace(/\s+/g, '');
      if (!/^[A-Z0-9-]{5,14}$/.test(code)) {
        mErr.textContent = 'Wpisz poprawny numer Paczkomatu, np. KRA010M.';
        return;
      }
      chooseByCode(code, 'wpisany ręcznie przez klienta', '');
    };
    mOk.addEventListener('click', submitManual);
    mInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitManual();
      }
    });

    d.append(form, status, mapEl, list, manualToggle, manual);

    let map = null;
    let layer = null;
    let abort = null;
    let timer = null;

    const pointCard = (p) => {
      const box = el('div', 'cp-pk-own__card');
      box.appendChild(el('strong', '', p.name));
      box.appendChild(el('span', '', addressOf(p)));
      const hours = p.opening_hours || '';
      const place = p.location_description || '';
      if (place || hours) box.appendChild(el('small', '', [place, hours].filter(Boolean).join(' · ')));
      const pick = el('button', 'cp-pk__btn', 'Wybierz ten Paczkomat');
      pick.type = 'button';
      pick.addEventListener('click', () => chooseByCode(p.name, addressOf(p), [place, hours].filter(Boolean).join(' · ')));
      box.appendChild(pick);
      return box;
    };

    const render = (items) => {
      layer.clearLayers();
      list.textContent = '';
      items.forEach((p) => {
        const loc = p.location || {};
        if (typeof loc.latitude !== 'number') return;
        const marker = window.L.marker([loc.latitude, loc.longitude], {
          icon: window.L.divIcon({
            className: 'cp-map-pin',
            html: '<span class="cp-map-pin__dot"></span>',
            iconSize: [28, 28],
            iconAnchor: [14, 26],
          }),
          title: p.name,
        });
        marker.bindPopup(pointCard(p), { minWidth: 220 });
        marker.addTo(layer);
      });
      items.slice(0, 8).forEach((p) => {
        const li = el('li', 'cp-pk-own__item');
        li.appendChild(pointCard(p));
        list.appendChild(li);
      });
    };

    const loadAround = async (lat, lon, radius) => {
      if (abort) abort.abort();
      abort = new AbortController();
      status.textContent = 'Szukam Paczkomatów...';
      try {
        const url = `${POINTS_API}?relative_point=${lat},${lon}&max_distance=${radius}&type=parcel_locker&per_page=60`;
        const res = await fetch(url, { signal: abort.signal });
        if (!res.ok) throw new Error('points');
        const data = await res.json();
        const items = (data.items || []).filter((p) => p.status === 'Operating');
        render(items);
        status.textContent = items.length
          ? `Znaleziono Paczkomatów: ${items.length}. Kliknij pinezkę albo wybierz z listy.`
          : 'Brak Paczkomatów w tym miejscu. Oddal mapę albo wpisz inną miejscowość.';
      } catch (e) {
        if (e.name === 'AbortError') return;
        status.textContent = 'Nie udało się pobrać listy Paczkomatów. Spróbuj ponownie albo wpisz numer ręcznie.';
      }
    };

    const refreshFromView = () => {
      if (!map) return;
      if (map.getZoom() < 12) {
        status.textContent = 'Przybliż mapę albo wpisz miejscowość, żeby zobaczyć Paczkomaty.';
        return;
      }
      const c = map.getCenter();
      const radius = Math.min(6000, Math.max(800, Math.round(c.distanceTo(map.getBounds().getNorthEast()))));
      loadAround(c.lat.toFixed(5), c.lng.toFixed(5), radius);
    };

    const goTo = (lat, lon) => {
      map.setView([lat, lon], 14);
    };

    /* --- wyszukiwanie miejsca po Enterze lub kliknięciu "Szukaj" --- */
    const geocode = async (q) => {
      const url = `${GEOCODE_API}?format=jsonv2&limit=1&countrycodes=pl&accept-language=pl&q=${encodeURIComponent(q)}`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const found = await res.json();
      return found.length ? { lat: Number(found[0].lat), lon: Number(found[0].lon) } : null;
    };

    /* kod pocztowy: pierwszy Paczkomat z tego kodu wskazuje okolicę (szybciej i dokładniej niż adres) */
    const fromPostcode = async (code) => {
      try {
        const res = await fetch(`${POINTS_API}?type=parcel_locker&post_code=${encodeURIComponent(code)}&per_page=1`);
        const data = await res.json();
        const loc = data.items && data.items[0] && data.items[0].location;
        if (loc) return { lat: loc.latitude, lon: loc.longitude };
      } catch (e) {
        /* przejdź do wyszukiwania adresu */
      }
      return geocode(`${code}, Polska`);
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const raw = input.value.trim();
      if (!raw) return;
      status.textContent = 'Szukam miejsca...';
      try {
        const post = raw.match(/^(\d{2})-?(\d{3})$/);
        const where = post ? await fromPostcode(`${post[1]}-${post[2]}`) : await geocode(`${raw}, Polska`);
        if (!where) {
          status.textContent = 'Nie znaleziono takiego miejsca. Spróbuj kodu pocztowego lub nazwy miasta.';
          return;
        }
        map.setView([where.lat, where.lon], post ? 14 : 13);
      } catch (err) {
        status.textContent = 'Nie udało się wyszukać miejsca. Spróbuj ponownie.';
      }
    });

    near.addEventListener('click', () => {
      if (!navigator.geolocation) {
        status.textContent = 'Ta przeglądarka nie udostępnia lokalizacji. Wpisz miejscowość.';
        return;
      }
      status.textContent = 'Ustalam lokalizację...';
      navigator.geolocation.getCurrentPosition(
        (pos) => goTo(pos.coords.latitude, pos.coords.longitude),
        () => {
          status.textContent = 'Nie udało się ustalić lokalizacji. Wpisz miejscowość lub kod pocztowy.';
        },
        { timeout: 8000 }
      );
    });

    /* mapę tworzymy dopiero, gdy okno jest widoczne (Leaflet liczy rozmiar kontenera) */
    d.cpInit = async () => {
      if (map) {
        map.invalidateSize();
        return;
      }
      try {
        await loadLeaflet();
      } catch (e) {
        status.textContent = 'Nie udało się załadować mapy. Wpisz numer Paczkomatu ręcznie.';
        manual.hidden = false;
        return;
      }
      const L = window.L;
      map = L.map(mapEl, { center: [52.1, 19.4], zoom: 6, zoomControl: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; OpenStreetMap, Paczkomaty: InPost',
      }).addTo(map);
      d.cpMap = map;
      layer = L.layerGroup().addTo(map);
      map.on('moveend', () => {
        clearTimeout(timer);
        timer = setTimeout(refreshFromView, 450);
      });
      setTimeout(() => map.invalidateSize(), 50);
    };

    return d;
  };

  const openPaczkomat = (root) => {
    activeRoot = root;
    const mode = root.dataset.mode === 'map' ? 'map' : 'own';
    if (mode === 'map') loadGeowidget(root.dataset.sandbox === 'true');
    if (!dialog || dialogMode !== mode) {
      if (dialog) dialog.remove();
      dialog = mode === 'map' ? buildGeowidgetDialog(root.dataset.token) : buildOwnMapDialog();
      dialogMode = mode;
    }
    if (typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('cp-no-scroll');
      if (typeof dialog.cpInit === 'function') dialog.cpInit();
    }
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-cp-deliver]');
    if (!btn) return;
    const root = btn.closest('[data-cp-delivery]');
    if (!root) return;
    if (btn.dataset.cpDeliver === 'Kurier') {
      saveAndCheckout(root, { Dostawa: 'Kurier', Paczkomat: '', 'Paczkomat adres': '' });
    } else {
      openPaczkomat(root);
    }
  });
})();
